var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGameLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 470,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1300v470H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#b)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#c)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m801 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#d)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#e)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#f)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#g)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#h)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#i)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#j)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#k)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#l)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1201 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#m)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#n)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1301 451 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#o)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#p)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#q)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#r)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m851 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#s)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#t)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#u)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#v)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#w)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#x)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#y)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#z)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1151 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#A)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1251 401 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#B)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#C)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#D)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m801 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#E)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#F)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#G)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#H)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#I)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#J)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#K)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#L)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#M)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1201 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#N)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#O)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1301 351 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#P)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#Q)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#R)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#S)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m851 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#T)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#U)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#V)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#W)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#X)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#Y)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#Z)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aa)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1151 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ab)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1251 301 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ac)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ad)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ae)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m801 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#af)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ag)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ah)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ai)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aj)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ak)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#al)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#am)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#an)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1201 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ao)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ap)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1301 251 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aq)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ar)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#as)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#at)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m851 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#au)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#av)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aw)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ax)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ay)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#az)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aA)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1151 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aB)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1251 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aC)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aD)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aE)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m801 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aF)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aG)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aH)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aI)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aJ)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aK)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aL)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aM)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aN)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1201 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aO)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aP)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1301 151 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aQ)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aR)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aS)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aT)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m851 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aU)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aV)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aW)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aX)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aY)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#aZ)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ba)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1151 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bb)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1251 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bc)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bd)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#be)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m801 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bf)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bg)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bh)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bi)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bj)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bk)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bl)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bm)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1201 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bn)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 51 50 50-50 50-50-50-1-1 1 1L1 51l-1-1 1 1Z",
    fill: "url(#bo)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1301 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bp)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bq)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#br)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bs)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m851 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bt)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bu)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 1 50 50-50 50L1 51l-1-1 1 1L51 1l-1-1 1 1Z",
    fill: "url(#bv)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bw)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bx)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#by)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bz)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bA)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1251 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bB)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bC)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bD)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m801-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bE)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bF)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bG)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bH)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1-49 51 1 1 51-49 1l-1-1 1 1L1-49l-1-1 1 1Z",
    fill: "url(#bI)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101-49 50 50-50 50L51 1l-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bJ)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bK)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bL)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bM)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bN)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1201-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bO)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1301-49 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bP)",
    stroke: "#E8E8E8",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 200h2l50 50v2l-50 50h-2l-50-50v-2l50-50Z",
    fill: "url(#bR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 201 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    stroke: "#EBEBEB",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bS)",
    d: "M0 0h1300v680H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bT)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 50h2l50 50v2l-50 50h-2l-50-50v-2l50-50Z",
    fill: "url(#bU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 51 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    stroke: "#EBEBEB",
    strokeOpacity: 0.8,
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bV)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M950 100h2l50 50v2l-50 50h-2l-50-50v-2l50-50Z",
    fill: "url(#bW)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 100h2l50 50v2l-50 50h-2l-50-50v-2l50-50Z",
    fill: "url(#bX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951 101 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    stroke: "#EBEBEB",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bY)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1151 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#bZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1151 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    fill: "url(#ca)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1151 1 50 50-50 50-50-50-1-1 1 1 50-50-1-1 1 1Z",
    stroke: "#EBEBEB",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1299 462-131-50c-60-23-154-44-218-51-70-7-90-9-160-10-45 0-110 13-110 13s-57 6-78 16c-20 9-26 16-26 16l15 76 64 81 531 24 192 20-79-135Z",
    fill: "url(#cc)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 462 131-50c60-23 153-44 217-51 70-7 141-14 211-15 45-1 67 31 67 31s46-2 68 8c19 9 27 34 27 34l-14 53-64 81-531 24-192 20L5 462Z",
    fill: "#67C4D7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ce)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453 432s51-25 87-35c35-10 56-16 93-16 34 1 53 4 85 16 38 14 87 57 87 57l-109 91H552l-99-113Z",
    fill: "#7CD994"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    fillOpacity: 0.4,
    d: "M633 0h667v573H633z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 702 0)",
    fill: "url(#cg)",
    fillOpacity: 0.4,
    d: "M0 0h702v585H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 601.1,
    y1: 449.6,
    x2: 601.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 701.1,
    y1: 449.6,
    x2: 701.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 801.1,
    y1: 449.6,
    x2: 801.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 901.1,
    y1: 449.6,
    x2: 901.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 201.1,
    y1: 449.6,
    x2: 201.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 301.1,
    y1: 449.6,
    x2: 301.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 101.1,
    y1: 449.6,
    x2: 101.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 401.1,
    y1: 449.6,
    x2: 401.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 501.1,
    y1: 449.6,
    x2: 501.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 1001.1,
    y1: 449.6,
    x2: 1001.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 1101.1,
    y1: 449.6,
    x2: 1101.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 1201.1,
    y1: 449.6,
    x2: 1201.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1.1,
    y1: 449.6,
    x2: 1.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 1301.1,
    y1: 449.6,
    x2: 1301.1,
    y2: 552.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 551.1,
    y1: 399.6,
    x2: 551.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 651.1,
    y1: 399.6,
    x2: 651.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 751.1,
    y1: 399.6,
    x2: 751.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 851.1,
    y1: 399.6,
    x2: 851.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 951.1,
    y1: 399.6,
    x2: 951.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 51.1,
    y1: 399.6,
    x2: 51.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 151.1,
    y1: 399.6,
    x2: 151.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 251.1,
    y1: 399.6,
    x2: 251.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 351.1,
    y1: 399.6,
    x2: 351.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 451.1,
    y1: 399.6,
    x2: 451.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 1051.1,
    y1: 399.6,
    x2: 1051.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 1151.1,
    y1: 399.6,
    x2: 1151.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 1251.1,
    y1: 399.6,
    x2: 1251.1,
    y2: 502.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 601.1,
    y1: 349.6,
    x2: 601.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 701.1,
    y1: 349.6,
    x2: 701.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 801.1,
    y1: 349.6,
    x2: 801.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 901.1,
    y1: 349.6,
    x2: 901.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 201.1,
    y1: 349.6,
    x2: 201.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 301.1,
    y1: 349.6,
    x2: 301.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 101.1,
    y1: 349.6,
    x2: 101.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 401.1,
    y1: 349.6,
    x2: 401.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 501.1,
    y1: 349.6,
    x2: 501.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 1001.1,
    y1: 349.6,
    x2: 1001.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 1101.1,
    y1: 349.6,
    x2: 1101.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 1201.1,
    y1: 349.6,
    x2: 1201.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 1.1,
    y1: 349.6,
    x2: 1.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 1301.1,
    y1: 349.6,
    x2: 1301.1,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 551.1,
    y1: 299.6,
    x2: 551.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 651.1,
    y1: 299.6,
    x2: 651.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 751.1,
    y1: 299.6,
    x2: 751.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 851.1,
    y1: 299.6,
    x2: 851.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 951.1,
    y1: 299.6,
    x2: 951.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 51.1,
    y1: 299.6,
    x2: 51.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 151.1,
    y1: 299.6,
    x2: 151.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 251.1,
    y1: 299.6,
    x2: 251.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 351.1,
    y1: 299.6,
    x2: 351.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 451.1,
    y1: 299.6,
    x2: 451.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 1051.1,
    y1: 299.6,
    x2: 1051.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 1151.1,
    y1: 299.6,
    x2: 1151.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 1251.1,
    y1: 299.6,
    x2: 1251.1,
    y2: 402.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 601.1,
    y1: 249.6,
    x2: 601.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 701.1,
    y1: 249.6,
    x2: 701.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 801.1,
    y1: 249.6,
    x2: 801.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 901.1,
    y1: 249.6,
    x2: 901.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 201.1,
    y1: 249.6,
    x2: 201.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 301.1,
    y1: 249.6,
    x2: 301.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 101.1,
    y1: 249.6,
    x2: 101.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 401.1,
    y1: 249.6,
    x2: 401.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 501.1,
    y1: 249.6,
    x2: 501.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 1001.1,
    y1: 249.6,
    x2: 1001.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 1101.1,
    y1: 249.6,
    x2: 1101.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 1201.1,
    y1: 249.6,
    x2: 1201.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 1.1,
    y1: 249.6,
    x2: 1.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 1301.1,
    y1: 249.6,
    x2: 1301.1,
    y2: 352.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 551.1,
    y1: 199.6,
    x2: 551.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 651.1,
    y1: 199.6,
    x2: 651.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 751.1,
    y1: 199.6,
    x2: 751.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 851.1,
    y1: 199.6,
    x2: 851.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 951.1,
    y1: 199.6,
    x2: 951.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 51.1,
    y1: 199.6,
    x2: 51.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 151.1,
    y1: 199.6,
    x2: 151.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 251.1,
    y1: 199.6,
    x2: 251.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 351.1,
    y1: 199.6,
    x2: 351.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 1051.1,
    y1: 199.6,
    x2: 1051.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 1151.1,
    y1: 199.6,
    x2: 1151.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 1251.1,
    y1: 199.6,
    x2: 1251.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 601.1,
    y1: 149.6,
    x2: 601.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 701.1,
    y1: 149.6,
    x2: 701.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 801.1,
    y1: 149.6,
    x2: 801.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 901.1,
    y1: 149.6,
    x2: 901.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 201.1,
    y1: 149.6,
    x2: 201.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 301.1,
    y1: 149.6,
    x2: 301.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 101.1,
    y1: 149.6,
    x2: 101.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 401.1,
    y1: 149.6,
    x2: 401.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 501.1,
    y1: 149.6,
    x2: 501.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 1001.1,
    y1: 149.6,
    x2: 1001.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 1101.1,
    y1: 149.6,
    x2: 1101.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 1201.1,
    y1: 149.6,
    x2: 1201.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 1.1,
    y1: 149.6,
    x2: 1.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 1301.1,
    y1: 149.6,
    x2: 1301.1,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 551.1,
    y1: 99.6,
    x2: 551.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 651.1,
    y1: 99.6,
    x2: 651.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 751.1,
    y1: 99.6,
    x2: 751.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 851.1,
    y1: 99.6,
    x2: 851.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 51.1,
    y1: 99.6,
    x2: 51.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 151.1,
    y1: 99.6,
    x2: 151.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 251.1,
    y1: 99.6,
    x2: 251.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 351.1,
    y1: 99.6,
    x2: 351.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 451.1,
    y1: 99.6,
    x2: 451.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 1051.1,
    y1: 99.6,
    x2: 1051.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 1151.1,
    y1: 99.6,
    x2: 1151.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 1251.1,
    y1: 99.6,
    x2: 1251.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 601.1,
    y1: 49.6,
    x2: 601.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 701.1,
    y1: 49.6,
    x2: 701.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 801.1,
    y1: 49.6,
    x2: 801.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 901.1,
    y1: 49.6,
    x2: 901.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 201.1,
    y1: 49.6,
    x2: 201.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 301.1,
    y1: 49.6,
    x2: 301.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 401.1,
    y1: 49.6,
    x2: 401.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 501.1,
    y1: 49.6,
    x2: 501.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 1001.1,
    y1: 49.6,
    x2: 1001.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 1101.1,
    y1: 49.6,
    x2: 1101.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 1201.1,
    y1: 49.6,
    x2: 1201.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 1.1,
    y1: 49.6,
    x2: 1.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 1301.1,
    y1: 49.6,
    x2: 1301.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 551.1,
    y1: -0.4,
    x2: 551.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 651.1,
    y1: -0.4,
    x2: 651.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 751.1,
    y1: -0.4,
    x2: 751.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 851.1,
    y1: -0.4,
    x2: 851.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 951.1,
    y1: -0.4,
    x2: 951.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 51.1,
    y1: -0.4,
    x2: 51.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 151.1,
    y1: -0.4,
    x2: 151.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 251.1,
    y1: -0.4,
    x2: 251.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 351.1,
    y1: -0.4,
    x2: 351.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 451.1,
    y1: -0.4,
    x2: 451.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 1051.1,
    y1: -0.4,
    x2: 1051.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 1251.1,
    y1: -0.4,
    x2: 1251.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 601.1,
    y1: -50.4,
    x2: 601.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 701.1,
    y1: -50.4,
    x2: 701.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 801.1,
    y1: -50.4,
    x2: 801.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 901.1,
    y1: -50.4,
    x2: 901.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 201.1,
    y1: -50.4,
    x2: 201.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 301.1,
    y1: -50.4,
    x2: 301.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 1.1,
    y1: -50.4,
    x2: 1.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 101.1,
    y1: -50.4,
    x2: 101.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 401.1,
    y1: -50.4,
    x2: 401.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 501.1,
    y1: -50.4,
    x2: 501.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 1001.1,
    y1: -50.4,
    x2: 1001.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 1101.1,
    y1: -50.4,
    x2: 1101.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 1201.1,
    y1: -50.4,
    x2: 1201.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 1301.1,
    y1: -50.4,
    x2: 1301.1,
    y2: 52.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 451.1,
    y1: 199.6,
    x2: 451.1,
    y2: 302.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 680,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 101.1,
    y1: 49.6,
    x2: 101.1,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 951.1,
    y1: 99.6,
    x2: 951.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 951.1,
    y1: 99.6,
    x2: 951.1,
    y2: 202.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 1151.1,
    y1: -0.4,
    x2: 1151.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 1151.1,
    y1: -0.4,
    x2: 1151.1,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 581.1,
    y1: 459.8,
    x2: 1303.4,
    y2: 407.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52CC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BC776"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bQ",
    x: 392,
    y: 200,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_576_1469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_576_1469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bT",
    x: 42,
    y: 50,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.717548 0 0 0 0 0.717548 0 0 0 0 0.717548 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_576_1469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_576_1469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bV",
    x: 890,
    y: 98,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_576_1469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_576_1469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bY",
    x: 1092,
    y: 0,
    width: 118,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_576_1469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_576_1469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cb",
    x: 466.5,
    y: 241.4,
    width: 1021.8,
    height: 465.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_576_1469"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cd",
    x: -185,
    y: 235.9,
    width: 1021,
    height: 470.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_576_1469"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ce",
    x: 343,
    y: 271.4,
    width: 571.5,
    height: 383.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_576_1469"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(120 650 377) scale(551.583 1019.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(129 351 166) scale(709.522 1343.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1300v470H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGameLight);
export default __webpack_public_path__ + "static/media/bg-game__light.b8752422e6edfb6e6ce59d9fd8ceef94.svg";
export { ForwardRef as ReactComponent };